import { useStyletron } from 'baseui'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverride, toObjectOverride } from 'baseui/helpers/overrides';
import { Icon, IconProps } from 'baseui/icon';
import { h } from 'preact';
import { forwardRef } from 'preact/compat';

export default forwardRef<SVGSVGElement, IconProps>((props: IconProps, ref) => {
    const [, theme] = useStyletron();
    const { title = 'Cafe', size, color, overrides = {},...restProps } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const SvgOverride = mergeOverride( // @ts-ignore
        { component: theme.icons?.Cafe ? theme.icons.Cafe : null },
        overrides?.Svg ? toObjectOverride(overrides.Svg) : {},
    );
    return (
        <Icon viewBox="0 96 960 960"
              ref={ref}
              title={title}
              size={size}
              color={color}
              overrides={{ Svg: SvgOverride }}
              {...restProps}>
            <path d="M160 936v-80h640v80H160Zm160-160q-66 0-113-47t-47-113V216h640q33 0 56.5 23.5T880 296v120q0 33-23.5 56.5T800 496h-80v120q0 66-47 113t-113 47H320Zm0-80h240q33 0 56.5-23.5T640 616V296H240v320q0 33 23.5 56.5T320 696Zm400-280h80V296h-80v120Zm-280 80Z" />
        </Icon>
    );
});
